import {
  Deposits,
  Lending,
  PoliciesAndProcedures,
  HumanResource,
  Executive,
} from "../icons";

const sidebarOptions = [
  {
    id: 1,
    name: "Policies and Procedures",
    indexName: "",
    icon: <PoliciesAndProcedures />,
  },
  {
    id: 2,
    name: "Lending",
    icon: <Lending />,
  },
  {
    id: 3,
    name: "Deposits",
    icon: <Deposits />,
  },
  {
    id: 4,
    name: "Human Resources",
    icon: <HumanResource />,
  },
  {
    id: 5,
    name: "Executive",
    icon: <Executive />,
  },
];

export default sidebarOptions;
